import { Outlet } from "react-router-dom";
import Backdrop from "./Backdrop";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { notificationActions } from "../store/notification-slice";


export default function GuestLayout() {

    let notification = useSelector(state => state.notification.notification)
    let dispatch = useDispatch()

    useEffect(() => {
        if (notification) {
            setTimeout(() => {
                dispatch(notificationActions.setNotification(null))
            }, 3000)
        }
    }, [notification])
    return <div className="bg-maryam" style={{ minHeight: '100vh', display: 'flex' }}>

        <main className="guest-layout" style={{ display: 'flex', flexDirection: 'column', width: '100%' }} >

            <Outlet />
        </main>

        {notification &&
            <div className={`notification alert ${notification.status ? 'bg-success' : 'bg-warning'}`} style={{ position: 'fixed', bottom: 0, right: 0 }} > {notification.message} </div>
        }


        <Backdrop />
    </div>

}